module.exports = __webpack_public_path__ + "img/164.15eea0a1.jpg";